import axios from "axios";

let pendingCount = 0;
let state = { pending: false, since: null };
const listeners = new Set();

const setState = (next) => {
    state = next;
    listeners.forEach((listener) => listener());
};

const beginRequest = () => {
    pendingCount += 1;
    if (pendingCount === 1) {
        setState({ pending: true, since: Date.now() });
    }
};

const endRequest = () => {
    pendingCount = Math.max(0, pendingCount - 1);
    if (pendingCount === 0) {
        setState({ pending: false, since: null });
    }
};

export const subscribeRequestStatus = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const getRequestStatusSnapshot = () => state;

if (!window.__requestStatusPatched) {
    window.__requestStatusPatched = true;

    axios.interceptors.request.use((config) => {
        beginRequest();
        return config;
    }, (error) => {
        endRequest();
        return Promise.reject(error);
    });
    axios.interceptors.response.use((response) => {
        endRequest();
        return response;
    }, (error) => {
        endRequest();
        return Promise.reject(error);
    });

    const originalFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
        beginRequest();
        try {
            return await originalFetch(...args);
        } finally {
            endRequest();
        }
    };
}
